export interface NavList {
  title: string;
  url: string;
  id: number;
  child: NavChild[];
  freeze?: number[];
}
export interface NavMenuList {
  title: string;
  url: string;
  id: number;
  child: NavMenuChild[];
  freeze?: boolean;
}

export interface NavChild {
  title: string;
  id: number;
  url: string;
  externalUrl?: boolean;
  isNewPage?: boolean;
  perms?: PermsNav[];
  active?: boolean; // default true
  freeze?: number[];
  onlyToFreeze?: boolean;
}

export interface NavMenuChild {
  title: string;
  id: number;
  url: string;
  externalUrl?: boolean;
  isNewPage?: boolean;
  perms?: PermsMenuNav[];
  active?: boolean; // default true
  freeze?: boolean;
  permission?: boolean;
  onlyToFreeze?: boolean;
}

export interface PermsNav {
  id: number;
  name: string;
  // [X: string]: number | number[];
  freeze: number[];
  onlyToFreeze?: boolean;
}
export interface PermsMenuNav {
  id: number;
  name: string;
  // [X: string]: number | number[];
  freeze: boolean;
  permission: boolean;
  onlyToFreeze?: boolean;
}

export class NavigationLite {
  [x: string]: NavigationLiteDetail;
}

export interface NavigationLiteDetail {
  id: number;
  perms?: NavigationLitePerms;
}

export interface NavigationLitePerms {
  [x: string]: number;
}
